import React from 'react';
import { IconSvgProps } from '@models/common';

const Humanizer: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.33388 4H4.66663V6.66643M17.9994 4H20.6666V6.66643M7.33388 20H4.66663V17.3336M17.9994 20H20.6666V17.3336M8.22179 16.4446C8.22179 13.9902 10.2121 12.0005 12.6672 12.0005C15.1223 12.0005 17.1126 13.9902 17.1126 16.4446H8.22179ZM12.6666 11.9995C14.1397 11.9995 15.3339 10.8057 15.3339 9.33304C15.3339 7.86041 14.1397 6.66661 12.6666 6.66661C11.1935 6.66661 9.99937 7.86041 9.99937 9.33304C9.99937 10.8057 11.1935 11.9995 12.6666 11.9995Z'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Humanizer;
